import React from 'react'
import Edit from '../../crud/edit'
import fields from '../fields'
import menuItems from '../menuItems'
import omit from 'lodash/omit'

const EditPage = props => (
  <Edit
    title='Edit Page'
    fields={fields}
    apiPath={`admin/cms_pages/${props.params.cmsPageId}`}
    successRedirectPath='/cms/pages'
    buildMenuItems={menuItems}
    serializePatchBody={cmsPage => omit(cmsPage, ['blocks'])}
  />
)

export default EditPage
